export default "__VITE_ASSET__2A8i5$1K__"